module.exports = __webpack_public_path__ + "img/1526864859.cc79ffb5.jpg";